export const calculateArrivalTime = (time: string, hoursToAdd: number): string => {
  const [timeStr, period] = time.split(' ');
  const [hours, minutes, seconds] = timeStr.split(':').map(Number);
  
  let totalHours = hours;
  if (period === 'PM' && hours !== 12) totalHours += 12;
  if (period === 'AM' && hours === 12) totalHours = 0;
  
  totalHours = (totalHours + hoursToAdd) % 24;
  
  const newPeriod = totalHours >= 12 ? 'PM' : 'AM';
  const displayHours = totalHours > 12 ? totalHours - 12 : totalHours === 0 ? 12 : totalHours;
  
  return `${String(displayHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${newPeriod}`;
};

export const calculateDepartureTime = (time: string, hoursBefore: number): string => {
  const [timeStr, period] = time.split(' ');
  const [hours, minutes, seconds] = timeStr.split(':').map(Number);
  
  let totalHours = hours;
  if (period === 'PM' && hours !== 12) totalHours += 12;
  if (period === 'AM' && hours === 12) totalHours = 0;
  
  totalHours = (totalHours - hoursBefore + 24) % 24;
  
  const newPeriod = totalHours >= 12 ? 'PM' : 'AM';
  const displayHours = totalHours > 12 ? totalHours - 12 : totalHours === 0 ? 12 : totalHours;
  
  return `${String(displayHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${newPeriod}`;
};